
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4Xs4O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("e0RWY")).AgileFooter; });

var $ieYUc = parcelRequire("ieYUc");

var $e0RWY = parcelRequire("e0RWY");

});
parcelRegister("ieYUc", function(module, exports) {
$parcel$export(module.exports, "AgileFooterTop", function () { return $561b0feeb1e52a1e$export$d82baf0fba1e4221; });
/* agile-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $7sBwx = parcelRequire("7sBwx");
// ==================================================================
// CSS styling
// ==================================================================
const $561b0feeb1e52a1e$var$containerStyle = null;
const $561b0feeb1e52a1e$var$rowStyle = null;
const $561b0feeb1e52a1e$var$linksWrapperStyle = null;
const $561b0feeb1e52a1e$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
};
const $561b0feeb1e52a1e$export$d82baf0fba1e4221 = ()=>{
    const intl = (0, $8e22h.default)();
    const links1 = [
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.agile-project-management",
                defaultMessage: "Agile project management"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/project-management")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.scrum",
                defaultMessage: "Scrum"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/scrum")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.kanban",
                defaultMessage: "Kanban"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/kanban")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.design",
                defaultMessage: "Design"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/design")
        }
    ];
    const links2 = [
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.software-development",
                defaultMessage: "Software development"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/software-development")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.product-management",
                defaultMessage: "Product management"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/product-management")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.teams",
                defaultMessage: "Teams"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/teams")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/agile-at-scale")
        },
        {
            text: intl.formatMessage({
                id: "AgileFooter.top.devOps",
                defaultMessage: "DevOps"
            }),
            href: (0, $kooLp.useLocalizedHref)("/agile/devops")
        }
    ];
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f37vkz _n3td7vkz _19bv7vkz _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsb1osq _11rm1hrf _19itidpf _1wyb1osq _s7n41q9y _vchhusvi _1akozwfg _c7s71tcg _4puv7vkz _1r3v1tcg"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ahbq1wug _12l21wug _1e0c1txw _2lx21bp4 _zulpzwfg _1bsb1osq _181n11p5 _1j8b1ags _1s3r162e"
            ]),
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_nd5l1d4v"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_syazpmk4 _1wyb1j6v _1dyznl7k _vwz410nf _k48pbfng _ect4kipj _1s181k92 _17gqcjiy"
                        ]),
                        style: {
                            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                        },
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                            id: "AgileFooter.top.agile-topics",
                            defaultMessage: "Agile Topics"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpzwfg _1j8b1t02"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)($561b0feeb1e52a1e$var$AgileLinkListContainer, {
                            links: links1
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)($561b0feeb1e52a1e$var$AgileLinkListContainer, {
                            links: links2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $dypTs.jsx)((0, $7sBwx.default), {
                    text: intl.formatMessage({
                        id: "AgileFooter.top.sign-up-for-more-agile",
                        defaultMessage: "Sign up for more agile articles and tutorials."
                    })
                })
            ]
        })
    });
};
const $561b0feeb1e52a1e$var$AgileLinkListContainer = ({ links: links })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1tcg"
        ]),
        children: links.map((linkProp)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2fk4i.Link), (0, $dPABA._)((0, $6ogO3._)({}, linkProp), {
                    type: "anchor",
                    className: (0, $2jatx.default)([
                        "_syaz1yg0 _1wyboxwj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                    }
                }))
            }, linkProp.text))
    });
};
var $561b0feeb1e52a1e$export$2e2bcd8739ae039 = $561b0feeb1e52a1e$export$d82baf0fba1e4221;

});
parcelRegister("7sBwx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e23798a3e16cecd5$export$2e2bcd8739ae039; });
/* agile-mailing-list-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $fJP6M = parcelRequire("fJP6M");

var $kbpa7 = parcelRequire("kbpa7");

var $2ve7k = parcelRequire("2ve7k");
const $e23798a3e16cecd5$var$validateEmail = (email)=>{
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const $e23798a3e16cecd5$export$943ba713541231aa = (props)=>{
    const location = (0, $2ve7k.useLocation)();
    const intl = (0, $8e22h.default)();
    const emptyEmailError = intl.formatMessage({
        id: "AgileFooter.top.emptyEmailError",
        defaultMessage: "This field is required"
    });
    const invalidEmailError = intl.formatMessage({
        id: "AgileFooter.top.invalidEmailError",
        defaultMessage: "This field requires a valid email address"
    });
    const [errorMessage, setErrorMessage] = (0, $gljCV.useState)("");
    const [isValidatingEmail, setIsValidatingEmail] = (0, $gljCV.useState)(false);
    const [emailInput, setEmailInput] = (0, $gljCV.useState)("");
    const [honeypotInput, setHoneypotInput] = (0, $gljCV.useState)("");
    const [signupSuccess, setSignupSuccess] = (0, $gljCV.useState)(false);
    const [consentConfig, setConsentConfig] = (0, $gljCV.useState)();
    (0, $gljCV.useEffect)(()=>{
        if (isValidatingEmail) {
            if (emailInput === "") setErrorMessage(emptyEmailError);
            else $e23798a3e16cecd5$var$validateEmail(emailInput) ? setErrorMessage("") : setErrorMessage(invalidEmailError);
        }
    }, [
        isValidatingEmail,
        emailInput,
        emptyEmailError,
        invalidEmailError
    ]);
    (0, $gljCV.useEffect)(()=>{
        getConsentConfig();
    }, []);
    const getConsentConfig = async ()=>{
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const consentConfigUrl = `${stargateUrl}/preferencesV2/consent-config`;
        await fetch(consentConfigUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST"
        }).then((response)=>response.json()).then((data)=>setConsentConfig(data)).catch(()=>{
            console.error("Failed to fetch consent config");
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsValidatingEmail(true);
        if (honeypotInput) return;
        const stargateUrl = "https://www.atlassian.com/gateway/api";
        const postUrl = `${stargateUrl}/preferencesV2/update`;
        // These are hardcoded values that are required by the endpoint.
        // https://bitbucket.org/atlassian/magnolia-resources/annotate/f65b7a5bf31677bcde32caa3305364c7ffb88808/resources/js/components/generic/exact-target-formV2.ts?at=qa
        await fetch(postUrl, {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json; charset=UTF-8"
            },
            method: "POST",
            body: JSON.stringify({
                consentCheckboxValue: true,
                consentLabelText: "",
                email: emailInput,
                formId: "10c5c932-68d7-4db6-b1d1-959f4255d218",
                formUrl: location.href,
                locale: (consentConfig === null || consentConfig === void 0 ? void 0 : consentConfig.locale) || "UNKNOWN",
                privacyPolicyText: "",
                site: "atlassian"
            })
        }).then(()=>setSignupSuccess(true)).catch(()=>{
            setErrorMessage(intl.formatMessage({
                id: "AgileFooter.top.signupError",
                defaultMessage: "An error occurred. Please try again."
            }));
        });
    };
    return /*#__PURE__*/ (0, $dypTs.jsx)($e23798a3e16cecd5$export$bcccbb2dd132b5ba, (0, $dPABA._)((0, $6ogO3._)({}, props), {
        errorMessage: errorMessage,
        setIsValidatingEmail: setIsValidatingEmail,
        emailInput: emailInput,
        setEmailInput: setEmailInput,
        setHoneypotInput: setHoneypotInput,
        signupSuccess: signupSuccess,
        handleSubmit: handleSubmit
    }));
};
const $e23798a3e16cecd5$export$bcccbb2dd132b5ba = (props)=>{
    const { text: text, showEyebrow: showEyebrow, errorMessage: errorMessage, setIsValidatingEmail: setIsValidatingEmail, emailInput: emailInput, setEmailInput: setEmailInput, setHoneypotInput: setHoneypotInput, signupSuccess: signupSuccess, handleSubmit: handleSubmit } = props;
    const intl = (0, $8e22h.default)();
    const subscribeText = intl.formatMessage({
        id: "AgileFooter.top.subscribe",
        defaultMessage: "Subscribe"
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_nd5l13q9"
        ]),
        children: [
            showEyebrow && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1p1dangw _1f491mrw _aetrb3bt _1ywu1ule _1i2f1hdd _1peqsxj9 _z0ai1ylp"
                ]),
                children: subscribeText
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                children: text
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                children: [
                    !signupSuccess && /*#__PURE__*/ (0, $dypTs.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                                    htmlFor: "email",
                                    className: (0, $2jatx.default)([
                                        "_1wyboxwj _syazvwuj"
                                    ]),
                                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                                        id: "AgileFooter.top.email",
                                        defaultMessage: "Email"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_6rtho7ao"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                                        id: "email",
                                        type: "email",
                                        placeholder: "email@example.com",
                                        onChange: (e)=>setEmailInput(e.target.value),
                                        onBlur: ()=>emailInput && setIsValidatingEmail(true),
                                        "aria-invalid": errorMessage ? true : undefined,
                                        className: (0, $2jatx.default)([
                                            "_bfhkcd5j _19it1ehm _2rko1l7b _1e0c1o8l _ect4bzd7 _1wyboxwj _vwz411nn _4t3i1ylp _12l2ftgi _p12fp3fh _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _1bsb1osq"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        }
                                    }),
                                    errorMessage && /*#__PURE__*/ (0, $dypTs.jsx)("label", {
                                        htmlFor: "email",
                                        className: (0, $2jatx.default)([
                                            "_1e0c1ule _1wyboxwj _syaz1sl2 _19pk1crf _2hwxidpf _otyr1crf _18u0idpf"
                                        ]),
                                        children: errorMessage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $dypTs.jsx)("input", {
                                    type: "text",
                                    name: "list name",
                                    "aria-label": "keep this field blank",
                                    onChange: (e)=>setHoneypotInput(e.target.value)
                                })
                            }),
                            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $fJP6M.default), {
                                    type: "secondary",
                                    text: subscribeText,
                                    inputType: "submit",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-product-key": "jiraSoftware",
                                        "data-event-container": "exactTargetForm"
                                    },
                                    "aria-label": subscribeText
                                })
                            })
                        ]
                    }),
                    signupSuccess && /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                            id: "AgileFooter.top.signup-success",
                            defaultMessage: "Thanks for signing up!"
                        })
                    })
                ]
            })
        ]
    });
};
var $e23798a3e16cecd5$export$2e2bcd8739ae039 = $e23798a3e16cecd5$export$943ba713541231aa;

});


parcelRegister("e0RWY", function(module, exports) {
$parcel$export(module.exports, "AgileFooter", function () { return $fbcf733515d5be19$export$ec65f9ca3425eb16; });
/* agile-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $bQjAr = parcelRequire("bQjAr");

var $8LaTa = parcelRequire("8LaTa");

var $ieYUc = parcelRequire("ieYUc");
// ==================================================================
// CSS styling
// ==================================================================
const $fbcf733515d5be19$var$agileFooterStyles = null;
const $fbcf733515d5be19$export$ec65f9ca3425eb16 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler })=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $bQjAr.default), {
        name: "agile-footer-v2",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("footer", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _bfhk1hxd _1e0c1txw _2lx2vrvc _1bah1h6o _66f11hxd _1gv8pxbi _1pgb1txw _1h0m1bp4 _14qq1osq _z72t1tcg _dk8g1txw _m9cj1fra _cg6bidpf _1end1wqb"
            ]),
            children: /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: "globalFooterContentContainer",
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $ieYUc.AgileFooterTop), {}),
                    /*#__PURE__*/ (0, $dypTs.jsx)((0, $8LaTa.GlobalFooterBottom), {
                        selectedLanguage: selectedLanguage,
                        onLanguageChangeHandler: onLanguageChangeHandler
                    })
                ]
            })
        })
    });

});


parcelRegister("76zkt", function(module, exports) {
$parcel$export(module.exports, "AgileHubSideNav", function () { return (parcelRequire("leeSY")).AgileHubSideNav; });
parcelRequire("leeSY");
parcelRequire("gUDGa");

});
parcelRegister("leeSY", function(module, exports) {
$parcel$export(module.exports, "AgileHubSideNav", function () { return $e115ff3a7644ad5b$export$f163550c1b6acb68; });
/* agile-overview-sidenav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $gUDGa = parcelRequire("gUDGa");
const $e115ff3a7644ad5b$export$f163550c1b6acb68 = ({ nodes: nodes })=>{
    const headerCss = null;
    const agileSideNavCss = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _c71l1icw _1reo1wug _18m91wug _kqsw1if8 _152ttudo _u7co1wug _1e0cglyw _181n1ule _dz5jkb7n _1q5legat",
            "agile-sidenav"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h5", {
                className: (0, $2jatx.default)([
                    "_1wyboxwj _k48p1fw0 _syazvwuj _1pfhidpf _6rthdlk8 _vwz410nf _1p1dangw _1dyzt94y _ect43aqo"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $iVyKn.default), {
                    id: "agile-overview-sidenav.browse-topics",
                    defaultMessage: "Browse Topics"
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $gUDGa.PageTree), {
                nodes: nodes
            })
        ]
    });
};

});
parcelRegister("gUDGa", function(module, exports) {
$parcel$export(module.exports, "PageTree", function () { return $18ddc7dd055949f5$export$73500bf5f2e2b0c4; });
/* page-tree.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $3SU2g = parcelRequire("3SU2g");

var $kooLp = parcelRequire("kooLp");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");
// eslint-disable-next-line complexity
const $18ddc7dd055949f5$var$PageTreeNode = ({ node: node })=>{
    const { name: name, urlSlug: urlSlug, children: children, level: level, isRoot: isRoot } = node;
    const location = (0, $1ka2O.useLocation)();
    const [isSelected, _setIsSelected] = (0, $gljCV.useState)(urlSlug && (0, $80kL5.isEqualUnlocalizedPathname)(location.pathname, urlSlug));
    // deeply find if any child is selected
    const hasSelectedChild = (0, $gljCV.useCallback)((currentNode)=>{
        if (currentNode.urlSlug && (0, $80kL5.isEqualUnlocalizedPathname)(location.pathname, currentNode.urlSlug)) return true;
        else if (currentNode.children) return currentNode.children.some((child)=>hasSelectedChild(child));
        return false;
    }, [
        location.pathname
    ]);
    const hasDropdown = isRoot && children;
    const [expanded, setExpanded] = (0, $gljCV.useState)(hasSelectedChild(node));
    const isRootSelected = isRoot && hasSelectedChild(node);
    const handleClick = ()=>{
        setExpanded(!expanded);
    };
    const wrapperCss = null;
    const navlinkCss = [
        null
    ];
    const navlinkSpanCss = null;
    const navlinkBulletCss = null;
    const navlinkIconCss = [
        null
    ];
    const navlinkACss = [
        null,
        isSelected && !isRoot && navlinkBulletCss
    ];
    const dropdownCss = [
        null,
        !expanded && null,
        expanded && null
    ];
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ahbq1ua3"
        ]),
        style: {
            "--_16epgcl": (0, $6ZVlx.default)(isRoot ? "0" : `${(level !== null && level !== void 0 ? level : 1) * 15}px`)
        },
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                onClick: handleClick,
                onKeyDown: handleClick,
                className: (0, $2jatx.default)([
                    "_1wyb1to8 _ca0qftgi _u5f3idpf _n3tdftgi _19bv1ylp _syaztx7j _k48p91rt _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _3fcw1g80 _1nmz1hna"
                ]),
                style: {
                    "--_129z960": (0, $6ZVlx.default)(isRoot ? "1rem" : ".9rem"),
                    "--_1tj0m80": (0, $6ZVlx.default)(isRootSelected ? "#091E42" : "#42526e"),
                    "--_r3az4g": (0, $6ZVlx.default)(isRootSelected || isSelected ? "600" : "400")
                },
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("span", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        hasDropdown && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                            "aria-label": expanded ? "collapse" : "expand",
                            className: (0, $2jatx.default)([
                                "_kqswstnw _1e02idpf _ahbqkqtd _152t1smr _8hrz8s7t _t9ec3qhy _v5641lvb",
                                "agile-sidenav-icon"
                            ]),
                            style: {
                                "--_cf3sb8": (0, $6ZVlx.default)(expanded ? "rotate(0deg)" : "rotate(-90deg)")
                            },
                            children: /*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3SU2g))), {
                                size: "large",
                                label: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                            "aria-label": `link to ${name}`,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "micrositeNav",
                            "data-product-key": "jiraSoftware",
                            href: (0, $kooLp.useLocalizedHref)(urlSlug !== null && urlSlug !== void 0 ? urlSlug : ""),
                            onClick: (e)=>{
                                isRoot && hasDropdown && e.preventDefault();
                            },
                            className: (0, $2jatx.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _9oik1r31 _1bnx8stv _jf4cnqa1",
                                isSelected && !isRoot && "_1kt9b3bt _1mp4idpf _kfgtidpf _iajmidpf _1fkridpf _pasc1wug _eid31wug _zr3e1wug _fntn1wug _14h81axk _rfx319bv _1cs8stnw _z5wt1fm0"
                            ]),
                            children: name !== undefined && name.length > 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1reo15vq _18m915vq",
                    !expanded && "_v564nino _c71lidpf",
                    expanded && "_v5646jez _c71lli4i"
                ]),
                children: children && /*#__PURE__*/ (0, $dypTs.jsx)($18ddc7dd055949f5$export$73500bf5f2e2b0c4, {
                    nodes: children
                })
            })
        ]
    });
};
const $18ddc7dd055949f5$export$73500bf5f2e2b0c4 = ({ nodes: nodes })=>{
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        children: nodes.map((node)=>/*#__PURE__*/ (0, $dypTs.jsx)($18ddc7dd055949f5$var$PageTreeNode, {
                node: node
            }, node.key))
    });
};

});



parcelRegister("1Enm0", function(module, exports) {
$parcel$export(module.exports, "useAgileHubPageTreeData", function () { return $6f50d8a1e2a43c3f$export$fdffb81740346f39; });

var $8e22h = parcelRequire("8e22h");
const $6f50d8a1e2a43c3f$export$fdffb81740346f39 = ()=>{
    const intl = (0, $8e22h.default)();
    const AgileHubPageTreeData = [
        {
            key: "manifesto",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.manifesto",
                defaultMessage: "Agile manifesto"
            }),
            urlSlug: "/agile/manifesto",
            level: 0,
            isRoot: true
        },
        {
            key: "scrum",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.scrum",
                defaultMessage: "Scrum"
            }),
            urlSlug: "/agile/scrum",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/scrum",
                    level: 0
                },
                {
                    key: "/agile/scrum/sprints",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprints",
                        defaultMessage: "Sprints"
                    }),
                    urlSlug: "/agile/scrum/sprints",
                    level: 1
                },
                {
                    key: "/agile/scrum/sprint-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprint-planning",
                        defaultMessage: "Sprint planning"
                    }),
                    urlSlug: "/agile/scrum/sprint-planning",
                    level: 1
                },
                {
                    key: "/agile/scrum/ceremonies",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-ceremonies",
                        defaultMessage: "Ceremonies"
                    }),
                    urlSlug: "/agile/scrum/ceremonies",
                    level: 1
                },
                {
                    key: "/agile/scrum/backlogs",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-backlogs",
                        defaultMessage: "Backlogs"
                    }),
                    urlSlug: "/agile/scrum/backlogs",
                    level: 1
                },
                {
                    key: "/agile/scrum/sprint-reviews",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-sprint-reviews",
                        defaultMessage: "Sprint reviews"
                    }),
                    urlSlug: "/agile/scrum/sprint-reviews",
                    level: 1
                },
                {
                    key: "/agile/scrum/standups",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-standups",
                        defaultMessage: "Standups"
                    }),
                    urlSlug: "/agile/scrum/standups",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-master",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-master",
                        defaultMessage: "Scrum master"
                    }),
                    urlSlug: "/agile/scrum/scrum-master",
                    level: 1
                },
                {
                    key: "/agile/scrum/retrospectives",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-retrospectives",
                        defaultMessage: "Retrospectives"
                    }),
                    urlSlug: "/agile/scrum/retrospectives",
                    level: 1
                },
                {
                    key: "/agile/scrum/distributed-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-distributed-scrum",
                        defaultMessage: "Distributed scrum"
                    }),
                    urlSlug: "/agile/scrum/distributed-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/roles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-roles",
                        defaultMessage: "Roles"
                    }),
                    urlSlug: "/agile/scrum/roles",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-of-scrums",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-of-scrums",
                        defaultMessage: "Scrum of scrums"
                    }),
                    urlSlug: "/agile/scrum/scrum-of-scrums",
                    level: 1
                },
                {
                    key: "/agile/scrum/artifacts",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-artifacts",
                        defaultMessage: "Agile scrum artifacts"
                    }),
                    urlSlug: "/agile/scrum/artifacts",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-scrum-metrics",
                        defaultMessage: "Scrum metrics"
                    }),
                    urlSlug: "/agile/scrum/scrum-metrics",
                    level: 1
                },
                {
                    key: "/agile/scrum/jira-confluence-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-jira-confluence-scrum",
                        defaultMessage: "Jira Confluence scrum"
                    }),
                    urlSlug: "/agile/scrum/jira-confluence-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/agile-vs-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-agile-vs-scrum",
                        defaultMessage: "Agile vs Scrum"
                    }),
                    urlSlug: "/agile/scrum/agile-vs-scrum",
                    level: 1
                },
                {
                    key: "/agile/scrum/backlog-refinement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-backlog-refinement",
                        defaultMessage: "Backlog Refinement Guide"
                    }),
                    urlSlug: "/agile/scrum/backlog-refinement",
                    level: 1
                },
                {
                    key: "/agile/scrum/scrum-master-project-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.scrum-master-project-manager",
                        defaultMessage: "Scrum master vs. project manager"
                    }),
                    urlSlug: "/agile/scrum/scrum-master-project-manager",
                    level: 1
                }
            ]
        },
        {
            key: "kanban",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.kanban",
                defaultMessage: "Kanban"
            }),
            urlSlug: "/agile/kanban",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/kanban",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/kanban",
                    level: 0
                },
                {
                    key: "/agile/kanban/boards",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-boards",
                        defaultMessage: "Boards"
                    }),
                    urlSlug: "/agile/kanban/boards",
                    level: 1
                },
                {
                    key: "/agile/kanban/wip-limits",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-wip-limits",
                        defaultMessage: "WIP limits"
                    }),
                    urlSlug: "/agile/kanban/wip-limits",
                    level: 1
                },
                {
                    key: "/agile/kanban/kanban-vs-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-kanban-vs-scrum",
                        defaultMessage: "Kanban vs Scrum"
                    }),
                    urlSlug: "/agile/kanban/kanban-vs-scrum",
                    level: 1
                },
                {
                    key: "/agile/kanban/kanplan",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-kanplan",
                        defaultMessage: "Kanplan"
                    }),
                    urlSlug: "/agile/kanban/kanplan",
                    level: 1
                },
                {
                    key: "/agile/kanban/cards",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.kanban-cards",
                        defaultMessage: "Kanban cards"
                    }),
                    urlSlug: "/agile/kanban/cards",
                    level: 1
                }
            ]
        },
        {
            key: "project-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.project-management",
                defaultMessage: "Agile project management"
            }),
            urlSlug: "/agile/project-management",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/project-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/project-management",
                    level: 0
                },
                {
                    key: "/agile/project-management/project-management-intro",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-management-intro",
                        defaultMessage: "Project management intro"
                    }),
                    urlSlug: "/agile/project-management/project-management-intro",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow",
                        defaultMessage: "Workflow"
                    }),
                    urlSlug: "/agile/project-management/workflow",
                    level: 1
                },
                {
                    key: "/agile/project-management/epics-stories-themes",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-epics-stories-themes",
                        defaultMessage: "Epics, stories, themes"
                    }),
                    urlSlug: "/agile/project-management/epics-stories-themes",
                    level: 1
                },
                {
                    key: "/agile/project-management/epics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-epics",
                        defaultMessage: "Epics"
                    }),
                    urlSlug: "/agile/project-management/epics",
                    level: 1
                },
                {
                    key: "/agile/project-management/user-stories",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-user-stories",
                        defaultMessage: "User Stories"
                    }),
                    urlSlug: "/agile/project-management/user-stories",
                    level: 1
                },
                {
                    key: "/agile/project-management/estimation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-estimation",
                        defaultMessage: "Estimation"
                    }),
                    urlSlug: "/agile/project-management/estimation",
                    level: 1
                },
                {
                    key: "/agile/project-management/metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-metrics",
                        defaultMessage: "Metrics"
                    }),
                    urlSlug: "/agile/project-management/metrics",
                    level: 1
                },
                {
                    key: "/agile/project-management/gantt-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-gantt-chart",
                        defaultMessage: "Gantt chart"
                    }),
                    urlSlug: "/agile/project-management/gantt-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/program-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-program-management",
                        defaultMessage: "Program management vs. project management"
                    }),
                    urlSlug: "/agile/project-management/program-management",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-baseline",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-baseline",
                        defaultMessage: "Project baseline"
                    }),
                    urlSlug: "/agile/project-management/project-baseline",
                    level: 1
                },
                {
                    key: "/agile/project-management/continuous-improvement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-continuous-improvement",
                        defaultMessage: "Continuous improvement"
                    }),
                    urlSlug: "/agile/project-management/continuous-improvement",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-principles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-principles",
                        defaultMessage: "Lean principles"
                    }),
                    urlSlug: "/agile/project-management/lean-principles",
                    level: 1
                },
                {
                    key: "/agile/project-management/3-pillars-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-3-pillars-scrum",
                        defaultMessage: "3 pillars of Scrum"
                    }),
                    urlSlug: "/agile/project-management/3-pillars-scrum",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-board",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-board",
                        defaultMessage: "Scrum Board"
                    }),
                    urlSlug: "/agile/project-management/scrum-board",
                    level: 1
                },
                {
                    key: "/agile/project-management/waterfall-methodology",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-waterfall-methodology",
                        defaultMessage: "Waterfall Methodology"
                    }),
                    urlSlug: "/agile/project-management/waterfall-methodology",
                    level: 1
                },
                {
                    key: "/agile/project-management/velocity-scrum",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-velocity-scrum",
                        defaultMessage: "Velocity in Scrum"
                    }),
                    urlSlug: "/agile/project-management/velocity-scrum",
                    level: 1
                },
                {
                    key: "/agile/project-management/definition-of-ready",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-definition-of-ready",
                        defaultMessage: "What is Definition of Ready"
                    }),
                    urlSlug: "/agile/project-management/definition-of-ready",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-vs-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-vs-agile",
                        defaultMessage: "Lean vs. agile"
                    }),
                    urlSlug: "/agile/project-management/lean-vs-agile",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrumban",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrumban",
                        defaultMessage: "Scrumban"
                    }),
                    urlSlug: "/agile/project-management/scrumban",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-methodology",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-methodology",
                        defaultMessage: "Lean Methodology"
                    }),
                    urlSlug: "/agile/project-management/lean-methodology",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-backlog",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-backlog",
                        defaultMessage: "Sprint backlog"
                    }),
                    urlSlug: "/agile/project-management/sprint-backlog",
                    level: 1
                },
                {
                    key: "/agile/project-management/burn-up-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-burn-up-chart",
                        defaultMessage: "Burn up chart"
                    }),
                    urlSlug: "/agile/project-management/burn-up-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/kanban-principles",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-kanban-principles",
                        defaultMessage: "4 kanban principles"
                    }),
                    urlSlug: "/agile/project-management/kanban-principles",
                    level: 1
                },
                {
                    key: "/agile/project-management/kanban-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-kanban-metrics",
                        defaultMessage: "4 kanban metrics"
                    }),
                    urlSlug: "/agile/project-management/kanban-metrics",
                    level: 1
                },
                {
                    key: "/agile/project-management/program-vs-project-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-program-vs-project-manager",
                        defaultMessage: "Program vs. Project Manager"
                    }),
                    urlSlug: "/agile/project-management/program-vs-project-manager",
                    level: 1
                },
                {
                    key: "/agile/project-management/gantt-chart-examples",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-gantt-chart-examples",
                        defaultMessage: "Gantt chart examples"
                    }),
                    urlSlug: "/agile/project-management/gantt-chart-examples",
                    level: 1
                },
                {
                    key: "/agile/project-management/definition-of-done",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-definition-of-done",
                        defaultMessage: "Definition of done"
                    }),
                    urlSlug: "/agile/project-management/definition-of-done",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-grooming",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-grooming",
                        defaultMessage: "Backlog grooming"
                    }),
                    urlSlug: "/agile/project-management/backlog-grooming",
                    level: 1
                },
                {
                    key: "/agile/project-management/lean-process-improvement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-lean-process-improvement",
                        defaultMessage: "Lean process improvement"
                    }),
                    urlSlug: "/agile/project-management/lean-process-improvement",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-refinement-meeting",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-refinement-meeting",
                        defaultMessage: "Backlog refinement meetings"
                    }),
                    urlSlug: "/agile/project-management/backlog-refinement-meeting",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-values",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-values",
                        defaultMessage: "Scrum values"
                    }),
                    urlSlug: "/agile/project-management/scrum-values",
                    level: 1
                },
                {
                    key: "/agile/project-management/scope-of-work",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scope-of-work",
                        defaultMessage: "Scope of work"
                    }),
                    urlSlug: "/agile/project-management/scope-of-work",
                    level: 1
                },
                {
                    key: "/agile/project-management/scrum-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-scrum-tools",
                        defaultMessage: "Scrum tools"
                    }),
                    urlSlug: "/agile/project-management/scrum-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-tools",
                        defaultMessage: "Tools"
                    }),
                    urlSlug: "/agile/project-management/tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-automation-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-automation-software",
                        defaultMessage: "Workflow automation software"
                    }),
                    urlSlug: "/agile/project-management/workflow-automation-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/templates",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-templates",
                        defaultMessage: "Templates"
                    }),
                    urlSlug: "/agile/project-management/templates",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-tracker",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-tracker",
                        defaultMessage: "Task tracker"
                    }),
                    urlSlug: "/agile/project-management/task-tracker",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-automation",
                        defaultMessage: "Workflow automation"
                    }),
                    urlSlug: "/agile/project-management/workflow-automation",
                    level: 1
                },
                {
                    key: "/agile/project-management/status-report",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-status-report",
                        defaultMessage: "Status report"
                    }),
                    urlSlug: "/agile/project-management/status-report",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-chart",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-chart",
                        defaultMessage: "Workflow chart"
                    }),
                    urlSlug: "/agile/project-management/workflow-chart",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-roadmap",
                        defaultMessage: "Project roadmap"
                    }),
                    urlSlug: "/agile/project-management/project-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-schedule",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-schedule",
                        defaultMessage: "Project schedule"
                    }),
                    urlSlug: "/agile/project-management/project-schedule",
                    level: 1
                },
                {
                    key: "/agile/project-management/issue-tracking-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-issue-tracking-software",
                        defaultMessage: "Tracking software"
                    }),
                    urlSlug: "/agile/project-management/issue-tracking-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/roadmap-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-roadmap-tools",
                        defaultMessage: "Roadmap tools"
                    }),
                    urlSlug: "/agile/project-management/roadmap-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/technology-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-technology-roadmap",
                        defaultMessage: "Technology roadmap"
                    }),
                    urlSlug: "/agile/project-management/technology-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-scheduling-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-scheduling-software",
                        defaultMessage: "Project scheduling software"
                    }),
                    urlSlug: "/agile/project-management/project-scheduling-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/backlog-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-backlog-management-tools",
                        defaultMessage: "Backlog management tools"
                    }),
                    urlSlug: "/agile/project-management/backlog-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-management",
                        defaultMessage: "Understanding workflow management strategies"
                    }),
                    urlSlug: "/agile/project-management/workflow-management",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-examples",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-examples",
                        defaultMessage: "Workflow examples"
                    }),
                    urlSlug: "/agile/project-management/workflow-examples",
                    level: 1
                },
                {
                    key: "/agile/project-management/create-project-roadmap",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-create-project-roadmap",
                        defaultMessage: "Create project roadmap"
                    }),
                    urlSlug: "/agile/project-management/create-project-roadmap",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-planning-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-planning-tools",
                        defaultMessage: "Sprint planning tools"
                    }),
                    urlSlug: "/agile/project-management/sprint-planning-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-demo",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-demo",
                        defaultMessage: "Sprint demo"
                    }),
                    urlSlug: "/agile/project-management/sprint-demo",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-timeline-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-timeline-software",
                        defaultMessage: "Project Timeline Software"
                    }),
                    urlSlug: "/agile/project-management/project-timeline-software",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-management-tools",
                        defaultMessage: "Top task management tools"
                    }),
                    urlSlug: "/agile/project-management/task-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-backlog-product-backlog",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-backlog-product-backlog",
                        defaultMessage: "Product backlog vs. sprint backlog"
                    }),
                    urlSlug: "/agile/project-management/sprint-backlog-product-backlog",
                    level: 1
                },
                {
                    key: "/agile/project-management/workflow-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-workflow-management-tools",
                        defaultMessage: "Top workflow management tools"
                    }),
                    urlSlug: "/agile/project-management/workflow-management-tools",
                    level: 1
                },
                {
                    key: "/agile/project-management/project-management-dependencies",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-project-management-dependencies",
                        defaultMessage: "Project dependencies"
                    }),
                    urlSlug: "/agile/project-management/project-management-dependencies",
                    level: 1
                },
                {
                    key: "/agile/project-management/task-management-dashboard",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-task-management-dashboard",
                        defaultMessage: "Task dashboard guide"
                    }),
                    urlSlug: "/agile/project-management/task-management-dashboard",
                    level: 1
                },
                {
                    key: "/agile/project-management/sprint-cadence",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-sprint-cadence",
                        defaultMessage: "Sprint cadence"
                    }),
                    urlSlug: "/agile/project-management/sprint-cadence",
                    level: 1
                },
                {
                    key: "/agile/project-management/fast-tracking",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.project-management-fast-tracking",
                        defaultMessage: "Fast tracking"
                    }),
                    urlSlug: "/agile/project-management/fast-tracking",
                    level: 1
                }
            ]
        },
        {
            key: "product-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.product-management",
                defaultMessage: "Product Management"
            }),
            urlSlug: "/agile/product-management",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/product-management",
                    level: 0
                },
                {
                    key: "/agile/product-management/product-roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-roadmaps",
                        defaultMessage: "Product Roadmaps"
                    }),
                    urlSlug: "/agile/product-management/product-roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-manager",
                        defaultMessage: "Product Manager"
                    }),
                    urlSlug: "/agile/product-management/product-manager",
                    level: 1
                },
                {
                    key: "/agile/product-management/tips-for-new-product-manager",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-tips-for-new-product-manager",
                        defaultMessage: "Tips for new product managers"
                    }),
                    urlSlug: "/agile/product-management/tips-for-new-product-manager",
                    level: 1
                },
                {
                    key: "/agile/product-management/roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-roadmaps",
                        defaultMessage: "Roadmaps"
                    }),
                    urlSlug: "/agile/product-management/roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/tips-for-presenting-product-roadmaps",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-tips-for-presenting-product-roadmaps",
                        defaultMessage: "Tips for presenting product roadmaps"
                    }),
                    urlSlug: "/agile/product-management/tips-for-presenting-product-roadmaps",
                    level: 1
                },
                {
                    key: "/agile/product-management/requirements",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-requirements",
                        defaultMessage: "Requirements"
                    }),
                    urlSlug: "/agile/product-management/requirements",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-analytics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-analytics",
                        defaultMessage: "Product analytics"
                    }),
                    urlSlug: "/agile/product-management/product-analytics",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development",
                        defaultMessage: "Product development"
                    }),
                    urlSlug: "/agile/product-management/product-development",
                    level: 1
                },
                {
                    key: "/agile/product-management/remote-product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-remote-product-management",
                        defaultMessage: "Remote product management"
                    }),
                    urlSlug: "/agile/product-management/remote-product-management",
                    level: 1
                },
                {
                    key: "/agile/product-management/minimum-viable-product",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-minimum-viable-product",
                        defaultMessage: "Minimal viable product"
                    }),
                    urlSlug: "/agile/product-management/minimum-viable-product",
                    level: 1
                },
                {
                    key: "/agile/product-management/discovery",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-discovery",
                        defaultMessage: "Product discovery"
                    }),
                    urlSlug: "/agile/product-management/discovery",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-specification",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-specification",
                        defaultMessage: "Product specification"
                    }),
                    urlSlug: "/agile/product-management/product-specification",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development-strategy",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development-strategy",
                        defaultMessage: "Product development strategy"
                    }),
                    urlSlug: "/agile/product-management/product-development-strategy",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-development-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-development-software",
                        defaultMessage: "Product development software"
                    }),
                    urlSlug: "/agile/product-management/product-development-software",
                    level: 1
                },
                {
                    key: "/agile/product-management/new-product-development-process",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-new-product-development-process",
                        defaultMessage: "New product development process"
                    }),
                    urlSlug: "/agile/product-management/new-product-development-process",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-management-kpis",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-management-kpis",
                        defaultMessage: "Product management KPIs"
                    }),
                    urlSlug: "/agile/product-management/product-management-kpis",
                    level: 1
                },
                {
                    key: "/agile/product-management/nps-score",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-nps-score",
                        defaultMessage: "Net Promoter Score (NPS)"
                    }),
                    urlSlug: "/agile/product-management/nps-score",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-critique",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-critique",
                        defaultMessage: "Product critique"
                    }),
                    urlSlug: "/agile/product-management/product-critique",
                    level: 1
                },
                {
                    key: "/agile/product-management/prioritization-framework",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-prioritization-framework",
                        defaultMessage: "Prioritization frameworks"
                    }),
                    urlSlug: "/agile/product-management/prioritization-framework",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-features",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-features",
                        defaultMessage: "Product features"
                    }),
                    urlSlug: "/agile/product-management/product-features",
                    level: 1
                },
                {
                    key: "/agile/product-management/product-management-tools",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-management-tools",
                        defaultMessage: "Product management tools"
                    }),
                    urlSlug: "/agile/product-management/product-management-tools",
                    level: 1
                },
                {
                    key: "/agile/product-management/plm",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-plm",
                        defaultMessage: "Product Lifecycle Management"
                    }),
                    urlSlug: "/agile/product-management/plm",
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/roadmap-software",
                    key: "/agile/product-management/roadmap-software",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-roadmap-software",
                        defaultMessage: "9 best roadmap software for teams"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch-checklist",
                    key: "/agile/product-management/product-launch-checklist",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch-checklist",
                        defaultMessage: "Product launch checklist"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-strategy",
                    key: "/agile/product-management/product-strategy",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-strategy",
                        defaultMessage: "Product strategy"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-engineering",
                    key: "/agile/product-management/product-engineering",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-engineering",
                        defaultMessage: "Product engineering"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-operations",
                    key: "/agile/product-management/product-operations",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-operations",
                        defaultMessage: "Product operations"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/portfolio-management",
                    key: "/agile/product-management/portfolio-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-portfolio-management",
                        defaultMessage: "Portfolio management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/pm-and-ai",
                    key: "/agile/product-management/pm-and-ai",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-pm-and-ai",
                        defaultMessage: "AI and product management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/growth-product-management",
                    key: "/agile/product-management/growth-product-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-growth-product-management",
                        defaultMessage: "Growth product management"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-metrics",
                    key: "/agile/product-management/product-metrics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-metrics",
                        defaultMessage: "Product metrics"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-release",
                    key: "/agile/product-management/product-release",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-release",
                        defaultMessage: "Product release"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/feature-request",
                    key: "/agile/product-management/feature-request",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-feature-request",
                        defaultMessage: "Feature request"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch",
                    key: "/agile/product-management/product-launch",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch",
                        defaultMessage: "Product launch"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-planning",
                    key: "/agile/product-management/product-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-planning",
                        defaultMessage: "Product planning"
                    }),
                    level: 1
                },
                {
                    urlSlug: "/agile/product-management/product-launch-event",
                    key: "/agile/product-management/product-launch-event",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.product-management-product-launch-event",
                        defaultMessage: "Product launch event"
                    }),
                    level: 1
                }
            ]
        },
        {
            key: "value-stream-management",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.value-stream-management",
                defaultMessage: "Value Stream Management"
            }),
            urlSlug: "/agile/value-stream-management",
            level: 0,
            isRoot: true
        },
        {
            key: "agile-at-scale",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            urlSlug: "/agile/agile-at-scale",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-at-scale",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-at-scale",
                    level: 0
                },
                {
                    key: "/agile/agile-at-scale/managing-an-agile-portfolio",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-managing-an-agile-portfolio",
                        defaultMessage: "Managing an agile portfolio"
                    }),
                    urlSlug: "/agile/agile-at-scale/managing-an-agile-portfolio",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/lean-portfolio-management",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-lean-portfolio-management",
                        defaultMessage: "Lean portfolio management"
                    }),
                    urlSlug: "/agile/agile-at-scale/lean-portfolio-management",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/okr",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-okr",
                        defaultMessage: "Okrs"
                    }),
                    urlSlug: "/agile/agile-at-scale/okr",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/long-term-agile-planning",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-long-term-agile-planning",
                        defaultMessage: "Long-term agile planning"
                    }),
                    urlSlug: "/agile/agile-at-scale/long-term-agile-planning",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/what-is-safe",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-what-is-safe",
                        defaultMessage: "What is SAFe?"
                    }),
                    urlSlug: "/agile/agile-at-scale/what-is-safe",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/spotify",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-spotify",
                        defaultMessage: "Spotify model"
                    }),
                    urlSlug: "/agile/agile-at-scale/spotify",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/scrum-at-scale",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-scrum-at-scale",
                        defaultMessage: "Organizational agility with Scrum@Scale"
                    }),
                    urlSlug: "/agile/agile-at-scale/scrum-at-scale",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/agile-iron-triangle",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-agile-iron-triangle",
                        defaultMessage: "Agile iron triangle"
                    }),
                    urlSlug: "/agile/agile-at-scale/agile-iron-triangle",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/less",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-less",
                        defaultMessage: "The Large-Scale Scrum (LeSS) framework"
                    }),
                    urlSlug: "/agile/agile-at-scale/less",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/using-improvement-kata-to-support-lean",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-using-improvement-kata-to-support-lean",
                        defaultMessage: "Using Improvement Kata to support lean"
                    }),
                    urlSlug: "/agile/agile-at-scale/using-improvement-kata-to-support-lean",
                    level: 1
                },
                {
                    key: "/agile/agile-at-scale/beyond-the-basics-whitepaper",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-at-scale-beyond-the-basics-whitepaper",
                        defaultMessage: "Beyond the basics whitepaper"
                    }),
                    urlSlug: "/agile/agile-at-scale/beyond-the-basics-whitepaper",
                    level: 1
                }
            ]
        },
        {
            key: "software-development",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.software-development",
                defaultMessage: "Software development"
            }),
            urlSlug: "/agile/software-development",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/software-development",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/software-development",
                    level: 0
                },
                {
                    key: "/agile/software-development/developer",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-developer",
                        defaultMessage: "Developer"
                    }),
                    urlSlug: "/agile/software-development/developer",
                    level: 1
                },
                {
                    key: "/agile/software-development/dev-managers-vs-scrum-masters",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-dev-managers-vs-scrum-masters",
                        defaultMessage: "Dev managers vs scrum masters"
                    }),
                    urlSlug: "/agile/software-development/dev-managers-vs-scrum-masters",
                    level: 1
                },
                {
                    key: "/agile/software-development/git",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-git",
                        defaultMessage: "Git"
                    }),
                    urlSlug: "/agile/software-development/git",
                    level: 1
                },
                {
                    key: "/agile/software-development/branching",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-branching",
                        defaultMessage: "Branching"
                    }),
                    urlSlug: "/agile/software-development/branching",
                    level: 1
                },
                {
                    key: "/agile/software-development/git-branching-video",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-git-branching-video",
                        defaultMessage: "Git branching video"
                    }),
                    urlSlug: "/agile/software-development/git-branching-video",
                    level: 1
                },
                {
                    key: "/agile/software-development/code-reviews",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-code-reviews",
                        defaultMessage: "Code reviews"
                    }),
                    urlSlug: "/agile/software-development/code-reviews",
                    level: 1
                },
                {
                    key: "/agile/software-development/release",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-release",
                        defaultMessage: "Release"
                    }),
                    urlSlug: "/agile/software-development/release",
                    level: 1
                },
                {
                    key: "/agile/software-development/technical-debt",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-technical-debt",
                        defaultMessage: "Technical debt"
                    }),
                    urlSlug: "/agile/software-development/technical-debt",
                    level: 1
                },
                {
                    key: "/agile/software-development/testing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-testing",
                        defaultMessage: "Testing"
                    }),
                    urlSlug: "/agile/software-development/testing",
                    level: 1
                },
                {
                    key: "/agile/software-development/incident-response",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-incident-response",
                        defaultMessage: "Incident response"
                    }),
                    urlSlug: "/agile/software-development/incident-response",
                    level: 1
                },
                {
                    key: "/agile/software-development/continuous-integration",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-continuous-integration",
                        defaultMessage: "Continuous integration"
                    }),
                    urlSlug: "/agile/software-development/continuous-integration",
                    level: 1
                },
                {
                    key: "/agile/software-development/sdlc",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-sdlc",
                        defaultMessage: "Sdlc"
                    }),
                    urlSlug: "/agile/software-development/sdlc",
                    level: 1
                },
                {
                    key: "/agile/software-development/bug-triage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-bug-triage",
                        defaultMessage: "Bug triage: definition, examples, and best practices"
                    }),
                    urlSlug: "/agile/software-development/bug-triage",
                    level: 1
                },
                {
                    key: "/agile/software-development/software-deployment",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.software-development-software-deployment",
                        defaultMessage: "Software deployment"
                    }),
                    urlSlug: "/agile/software-development/software-deployment",
                    level: 1
                }
            ]
        },
        {
            key: "design",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.design",
                defaultMessage: "Design"
            }),
            urlSlug: "/agile/design",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/design",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/design",
                    level: 0
                },
                {
                    key: "/agile/design/product-design-process-customer-interview",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-product-design-process-customer-interview",
                        defaultMessage: "Product design process customer interview"
                    }),
                    urlSlug: "/agile/design/product-design-process-customer-interview",
                    level: 1
                },
                {
                    key: "/agile/design/collaborative-design-in-agile-teams-video",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.design-collaborative-design-in-agile-teams-video",
                        defaultMessage: "Collaborative design in agile teams video"
                    }),
                    urlSlug: "/agile/design/collaborative-design-in-agile-teams-video",
                    level: 1
                }
            ]
        },
        {
            key: "agile-marketing",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-marketing",
                defaultMessage: "Agile marketing"
            }),
            urlSlug: "/agile/agile-marketing",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-marketing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-marketing",
                    level: 0
                },
                {
                    key: "/agile/agile-marketing/what-is-agile-marketing",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-what-is-agile-marketing",
                        defaultMessage: "What is Agile Marketing?"
                    }),
                    urlSlug: "/agile/agile-marketing/what-is-agile-marketing",
                    level: 1
                },
                {
                    key: "/agile/agile-marketing/agile-marketing-team",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-marketing-agile-marketing-team",
                        defaultMessage: "How to create an agile marketing team"
                    }),
                    urlSlug: "/agile/agile-marketing/agile-marketing-team",
                    level: 1
                }
            ]
        },
        {
            key: "advantage",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.advantage",
                defaultMessage: "The agile advantage"
            }),
            urlSlug: "/agile/advantage",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/advantage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/advantage",
                    level: 0
                },
                {
                    key: "/agile/advantage/connect-business-strategy-to-development-reality",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-connect-business-strategy-to-development-reality",
                        defaultMessage: "Connecting business strategy to development reality"
                    }),
                    urlSlug: "/agile/advantage/connect-business-strategy-to-development-reality",
                    level: 1
                },
                {
                    key: "/agile/advantage/agile-is-a-competitive-advantage",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-agile-is-a-competitive-advantage",
                        defaultMessage: "Agile is a competitive advantage"
                    }),
                    urlSlug: "/agile/advantage/agile-is-a-competitive-advantage",
                    level: 1
                },
                {
                    key: "/agile/advantage/agile-mindset",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-agile-mindset",
                        defaultMessage: "Cultivating an agile mindset"
                    }),
                    urlSlug: "/agile/advantage/agile-mindset",
                    level: 1
                },
                {
                    key: "/agile/advantage/going-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.advantage-going-agile",
                        defaultMessage: "Going agile"
                    }),
                    urlSlug: "/agile/advantage/going-agile",
                    level: 1
                }
            ]
        },
        {
            key: "devops",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.devops",
                defaultMessage: "DevOps"
            }),
            urlSlug: "/agile/devops",
            level: 0,
            isRoot: true
        },
        {
            key: "teams",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.teams",
                defaultMessage: "Agile Teams"
            }),
            urlSlug: "/agile/teams",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/teams",
                    level: 0
                },
                {
                    key: "/agile/teams/remote-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-remote-teams",
                        defaultMessage: "Remote teams"
                    }),
                    urlSlug: "/agile/teams/remote-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/working-with-specialists",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-working-with-specialists",
                        defaultMessage: "Working with specialists"
                    }),
                    urlSlug: "/agile/teams/working-with-specialists",
                    level: 1
                },
                {
                    key: "/agile/teams/release-ready-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-release-ready-teams",
                        defaultMessage: "Release ready teams"
                    }),
                    urlSlug: "/agile/teams/release-ready-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/agilents-agile-transformation-journey",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-agilents-agile-transformation-journey",
                        defaultMessage: "Agilent\u2019s agile transformation journey"
                    }),
                    urlSlug: "/agile/teams/agilents-agile-transformation-journey",
                    level: 1
                },
                {
                    key: "/agile/teams/advanced-roadmaps-teams",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-advanced-roadmaps-teams",
                        defaultMessage: "Advanced Roadmaps"
                    }),
                    urlSlug: "/agile/teams/advanced-roadmaps-teams",
                    level: 1
                },
                {
                    key: "/agile/teams/jira-twitter-unified-projects-teamwork",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-jira-twitter-unified-projects-teamwork",
                        defaultMessage: "How Twitter uses Jira"
                    }),
                    urlSlug: "/agile/teams/jira-twitter-unified-projects-teamwork",
                    level: 1
                },
                {
                    key: "/agile/teams/scrum-kanban-agile",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.teams-scrum-kanban-agile",
                        defaultMessage: "How we chose our agile"
                    }),
                    urlSlug: "/agile/teams/scrum-kanban-agile",
                    level: 1
                }
            ]
        },
        {
            key: "tutorials",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.tutorials",
                defaultMessage: "Agile tutorials"
            }),
            urlSlug: "/agile/tutorials",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/tutorials",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/tutorials",
                    level: 0
                },
                {
                    key: "/agile/tutorials/jira-confluence-sprint-refinement",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-jira-confluence-sprint-refinement",
                        defaultMessage: "Jira and Confluence sprint refinement"
                    }),
                    urlSlug: "/agile/tutorials/jira-confluence-sprint-refinement",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-do-scrum-with-jira",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-do-scrum-with-jira-software",
                        defaultMessage: "How to do scrum with Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-do-scrum-with-jira",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-do-kanban-with-jira",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-do-kanban-with-jira-software",
                        defaultMessage: "Learn kanban with Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-do-kanban-with-jira",
                    level: 1
                },
                {
                    key: "/agile/tutorials/epics",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-epics",
                        defaultMessage: "Learn how to use Epics in Jira"
                    }),
                    urlSlug: "/agile/tutorials/epics",
                    level: 1
                },
                {
                    key: "/agile/tutorials/creating-your-agile-board",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-creating-your-agile-board",
                        defaultMessage: "Learn how to create an agile board in Jira"
                    }),
                    urlSlug: "/agile/tutorials/creating-your-agile-board",
                    level: 1
                },
                {
                    key: "/agile/tutorials/sprints",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-sprints",
                        defaultMessage: "Learn how to use sprints in Jira"
                    }),
                    urlSlug: "/agile/tutorials/sprints",
                    level: 1
                },
                {
                    key: "/agile/tutorials/versions",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-versions",
                        defaultMessage: "Learn Versions with Jira"
                    }),
                    urlSlug: "/agile/tutorials/versions",
                    level: 1
                },
                {
                    key: "/agile/tutorials/issues",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-issues",
                        defaultMessage: "Learn Issues with Jira"
                    }),
                    urlSlug: "/agile/tutorials/issues",
                    level: 1
                },
                {
                    key: "/agile/tutorials/burndown-charts",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-burndown-charts",
                        defaultMessage: "Learn burndown charts with Jira"
                    }),
                    urlSlug: "/agile/tutorials/burndown-charts",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-auto-create-subtasks-with-jira-software-automation",
                        defaultMessage: "Auto-create sub-tasks and update fields in Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-automatically-assign-issues-with-jira-software-automation",
                        defaultMessage: "How to automatically assign issues with Jira Automation"
                    }),
                    urlSlug: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-sync-epics-stories-with-jira-software-automation",
                        defaultMessage: "How to sync epics stories with Jira Automation"
                    }),
                    urlSlug: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation",
                    level: 1
                },
                {
                    key: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.tutorials-how-to-escalate-overdue-issues-with-jira-software-automation",
                        defaultMessage: "Automatically escalate overdue issues in Jira"
                    }),
                    urlSlug: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation",
                    level: 1
                }
            ]
        },
        {
            key: "agile-conversations",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.agile-conversations",
                defaultMessage: "Agile conversations"
            }),
            urlSlug: "/agile/agile-conversations",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/agile-conversations",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/agile-conversations",
                    level: 0
                },
                {
                    key: "/agile/agile-conversations/marketing-agility",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-marketing-agility",
                        defaultMessage: "Unlocking marketing agility"
                    }),
                    urlSlug: "/agile/agile-conversations/marketing-agility",
                    level: 1
                },
                {
                    key: "/agile/agile-conversations/customer-research-tips",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-customer-research-tips",
                        defaultMessage: "The power of agile and customer insights"
                    }),
                    urlSlug: "/agile/agile-conversations/customer-research-tips",
                    level: 1
                },
                {
                    key: "/agile/agile-conversations/think-big-work-small",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.agile-conversations-think-big-work-small",
                        defaultMessage: "Think big, work small"
                    }),
                    urlSlug: "/agile/agile-conversations/think-big-work-small",
                    level: 1
                }
            ]
        },
        {
            key: "about",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.about",
                defaultMessage: "About the Agile Coach"
            }),
            urlSlug: "/agile/about",
            level: 0,
            isRoot: true,
            children: [
                {
                    key: "/agile/about",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-overview",
                        defaultMessage: "Overview"
                    }),
                    urlSlug: "/agile/about",
                    level: 0
                },
                {
                    key: "/agile/about/dan-radigan",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-dan-radigan",
                        defaultMessage: "Dan Radigan"
                    }),
                    urlSlug: "/agile/about/dan-radigan",
                    level: 1
                },
                {
                    key: "/agile/about/max-rehkopf",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-max-rehkopf",
                        defaultMessage: "Max Rehkopf"
                    }),
                    urlSlug: "/agile/about/max-rehkopf",
                    level: 1
                },
                {
                    key: "/agile/about/claire-drumond",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-claire-drumond",
                        defaultMessage: "Claire Drumond"
                    }),
                    urlSlug: "/agile/about/claire-drumond",
                    level: 1
                },
                {
                    key: "/agile/about/laura-daly",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-laura-daly",
                        defaultMessage: "Laura Daly"
                    }),
                    urlSlug: "/agile/about/laura-daly",
                    level: 1
                },
                {
                    key: "/agile/about/sherif-mansour",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-sherif-mansour",
                        defaultMessage: "Sherif Mansour"
                    }),
                    urlSlug: "/agile/about/sherif-mansour",
                    level: 1
                },
                {
                    key: "/agile/about/martin-suntinger",
                    name: intl.formatMessage({
                        id: "AgileOverview.sidenav.about-martin-suntinger",
                        defaultMessage: "Martin Suntinger"
                    }),
                    urlSlug: "/agile/about/martin-suntinger",
                    level: 1
                }
            ]
        },
        {
            key: "articles",
            name: intl.formatMessage({
                id: "AgileOverview.sidenav.articles",
                defaultMessage: "All articles"
            }),
            urlSlug: "/agile/articles",
            level: 0,
            isRoot: true
        }
    ];
    return AgileHubPageTreeData;
};

});

parcelRegister("acgWW", function(module, exports) {
$parcel$export(module.exports, "RichContent", function () { return $f3f2f5e0d4b3588e$export$9d332a2389d1bc72; });
// TODO: Move/refactor these components into this "rich-content" space

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gtz2R = parcelRequire("gtz2R");

var $hS8MU = parcelRequire("hS8MU");

var $B5GRx = parcelRequire("B5GRx");

var $djGM1 = parcelRequire("djGM1");

var $bh8qW = parcelRequire("bh8qW");

var $amdZs = parcelRequire("amdZs");

var $cIEeV = parcelRequire("cIEeV");

var $2TQtV = parcelRequire("2TQtV");

var $dWJQD = parcelRequire("dWJQD");
const $f3f2f5e0d4b3588e$export$9d332a2389d1bc72 = (data)=>{
    if ((0, $dWJQD.isTextComponent)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $B5GRx.RichTextComponent), (0, $6ogO3._)({}, data));
    else if ((0, $dWJQD.isEmbedComponent)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $gtz2R.AgileVideo), {
        embedLink: data.embedded || "",
        title: data.embeddedVideoAssetName || "",
        thumbnail: data.embedAssetOverlay
    });
    else if ((0, $dWJQD.isProTipText)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $bh8qW.ProTipTextComponent), (0, $6ogO3._)({}, data));
    else if ((0, $dWJQD.isTwitterComponent)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $cIEeV.TwitterTextComponent), (0, $6ogO3._)({}, data));
    else if ((0, $dWJQD.isAssetComponent)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $hS8MU.BodyAssetComponent), (0, $6ogO3._)({}, data));
    else if ((0, $dWJQD.isCallToAction)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $2TQtV.ProductCTA), (0, $6ogO3._)({
        name: ""
    }, data));
    else if ((0, $dWJQD.isCallOutComponent)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $djGM1.CallOutComponent), (0, $6ogO3._)({}, data));
    else if ((0, $dWJQD.isQuestionComponent)(data)) return /*#__PURE__*/ (0, $dypTs.jsx)((0, $amdZs.QuestionComponent), (0, $6ogO3._)({}, data));
    return null;
};

});
parcelRegister("hS8MU", function(module, exports) {
$parcel$export(module.exports, "BodyAssetComponent", function () { return $f5940faffcd5fa0f$export$fdfd397940e11f58; });
/* body-asset.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $HMZ3r = parcelRequire("HMZ3r");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $f5940faffcd5fa0f$export$fdfd397940e11f58 = (data)=>{
    var _data_asset, _data_asset1, _data_asset2, _data_asset3;
    // NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
    const bodyAssetCss = null;
    const layout = data.assetRelatedText ? "6-6" : "12";
    const localeCode = (0, $kooLp.useLocale)();
    const html = (0, $gljCV.useMemo)(()=>{
        let initialHtml = data.assetRelatedText || "";
        // Hacky stuff: Need to wrap tables in a div to make them scrollable
        const tableRegex = /<table[^>]*>[\s\S]*?<\/table>/g;
        const tableMatch = initialHtml.match(tableRegex);
        if (tableMatch) {
            const tableHtml = tableMatch[0];
            const newTableHtml = `<div class="table-wrapper">${tableHtml}</div>`;
            initialHtml = initialHtml.replace(tableHtml, newTableHtml);
        }
        // Hacky stuff pt2: Need to fix relative localized links
        const relativeLinkRegex = RegExp('(?:\\"https:\\/\\/\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(relativeLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $kooLp.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        });
        // handle case where link is relative and not localized
        const relativeUrlRegex = new RegExp(`href="\\/(${localeCode}\\/)?([^"]*)"`, "g");
        initialHtml = initialHtml.replace(relativeUrlRegex, (_match, _p1, _p2)=>{
            // If the locale code is already present, return the match as is
            if (_p1) return _match;
            // Otherwise, prepend the locale code to the URL
            return `href="/${localeCode}/${_p2}"`;
        });
        // handle case where absolute WAC links are not localized
        const absolutePathRegex = RegExp('\\"https:\\/\\/www\\.atlassian\\.com\\/(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(absolutePathRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $kooLp.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        });
        // Hacky stuff pt3: replace &amp;nbsp; with &nbsp;
        initialHtml = initialHtml.replace(/&amp;nbsp;/g, "&nbsp;");
        return initialHtml;
    }, [
        data.assetRelatedText,
        localeCode
    ]);
    var _data_asset_description, _ref;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261g80 _rtys1osq _bna71wug _fvk9idpf _6bbsidpf _q7gq19as _zcqxbs82 _1v71idpf _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.Row), {
            layout: layout,
            alignItems: "top",
            children: [
                /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $HMZ3r.default), {
                        src: (_data_asset = data.asset) === null || _data_asset === void 0 ? void 0 : _data_asset.url,
                        alt: (_ref = (_data_asset_description = (_data_asset1 = data.asset) === null || _data_asset1 === void 0 ? void 0 : _data_asset1.description) !== null && _data_asset_description !== void 0 ? _data_asset_description : (_data_asset2 = data.asset) === null || _data_asset2 === void 0 ? void 0 : _data_asset2.name) !== null && _ref !== void 0 ? _ref : "",
                        baseWidth: 740,
                        contentType: (_data_asset3 = data.asset) === null || _data_asset3 === void 0 ? void 0 : _data_asset3.contentType
                    })
                }),
                data.assetRelatedText && /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            ]
        })
    });
};

});

parcelRegister("djGM1", function(module, exports) {
$parcel$export(module.exports, "CallOutComponent", function () { return $1462f30e081fcbe4$export$83ebdc814321a04a; });

var $dypTs = parcelRequire("dypTs");

var $c1m7K = parcelRequire("c1m7K");
const $1462f30e081fcbe4$export$83ebdc814321a04a = (data)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $c1m7K.InfoText), {
        text: data.callOutText,
        type: "html",
        headingText: data.title
    });

});
parcelRegister("c1m7K", function(module, exports) {
$parcel$export(module.exports, "InfoText", function () { return $c72f2fe546849445$export$ed2cd9eb2d1973f0; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $c72f2fe546849445$var$InfoSvg = ()=>/*#__PURE__*/ (0, $dypTs.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36.01",
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("title", {
                children: "status-exclaim"
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $dypTs.jsx)("g", {
                    id: "N700",
                    children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
                        fill: "#243858",
                        d: "M18,0A18.27,18.27,0,0,0,0,18.32,17.73,17.73,0,0,0,18,36,18.27,18.27,0,0,0,36,17.69,17.73,17.73,0,0,0,18,0ZM17,9A1,1,0,1,1,19,9V20.45a1,1,0,0,1-2.09,0Zm1,19a1.86,1.86,0,1,1,1.86-1.86A1.87,1.87,0,0,1,18,28Z"
                    })
                })
            })
        ]
    });
const $c72f2fe546849445$export$ed2cd9eb2d1973f0 = (data)=>{
    const iconWrapperCss = null;
    const flexContainerCss = null;
    const textContainerCss = null;
    const eyebrowCss = null;
    const textCss = null;
    const linkCss = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261q9c _4cvr1h6o _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1bsb1ul9 _4t3i1ul9 _12l21m13 _1sb2b3bt _ouxlidpf _1lrw1f51"
                ]),
                children: !data.hideIcon && /*#__PURE__*/ (0, $dypTs.jsx)($c72f2fe546849445$var$InfoSvg, {})
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1bsb1osq _191w9o2f _ca0qyh40 _u5f3idpf _n3tdyh40 _19bv1ul9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_syazvwuj _1wyb1j6v _vwz41ikt _k48p4jg8 _1p1dangw _6rth19bv _ect41pz4"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                        },
                        children: data.headingText && data.headingText
                    }),
                    data.type === "html" ? /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: data.text
                        },
                        className: (0, $2jatx.default)([
                            "_1pfh1wug _6rth1wug _syaz1mpp _1wyb19as",
                            "_43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1"
                        ])
                    }) : data.type === "component" ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1pfh1wug _6rth1wug _syaz1mpp _1wyb19as"
                        ]),
                        children: data.children
                    }) : /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_1pfh1wug _6rth1wug _syaz1mpp _1wyb19as"
                        ]),
                        children: data.text
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("bh8qW", function(module, exports) {
$parcel$export(module.exports, "ProTipTextComponent", function () { return $ad5ed34b4b674330$export$1d1201405e1543cb; });

var $dypTs = parcelRequire("dypTs");

var $8e22h = parcelRequire("8e22h");

var $c1m7K = parcelRequire("c1m7K");
const $ad5ed34b4b674330$export$1d1201405e1543cb = (data)=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $c1m7K.InfoText), {
        text: data.proTipText,
        headingText: intl.formatMessage({
            id: "agile.overview.protip",
            defaultMessage: "Pro Tip:"
        })
    });
};

});

parcelRegister("amdZs", function(module, exports) {
$parcel$export(module.exports, "QuestionComponent", function () { return $5dd775354eab71a0$export$640700a7579a4d9c; });

var $dypTs = parcelRequire("dypTs");

var $c1m7K = parcelRequire("c1m7K");
const $5dd775354eab71a0$export$640700a7579a4d9c = (data)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, $c1m7K.InfoText), {
        text: data.answer,
        type: "html",
        headingText: data.questionTitle
    });

});

parcelRegister("cIEeV", function(module, exports) {
$parcel$export(module.exports, "TwitterTextComponent", function () { return $26fc9bed1c3ff3a9$export$f03ace5c63ba1512; });
/* twitter-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
const $26fc9bed1c3ff3a9$export$f03ace5c63ba1512 = (data)=>{
    const iconWrapperCss = null;
    const flexContainerCss = null;
    const textContainerCss = null;
    const tweetTextCss = null;
    const localizedUrl = data.tweetText ? encodeURI("https://twitter.com/intent/tweet?text=" + data.tweetText) : "";
    var _data_tweetText;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1n261q9c _4cvr1h6o _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1bsb1ul9 _4t3i1ul9 _12l2o61n _11q716fq _1sb2b3bt _ouxlidpf _1lrw1f51"
                ])
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1bsb1osq _191w9o2f _ca0qyh40 _u5f3idpf _n3tdyh40 _19bv1ul9"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                    href: localizedUrl,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "panel",
                    "data-product-key": "jiraSoftware",
                    className: (0, $2jatx.default)([
                        "_1pfh1wug _6rth1wug _1wyb1k8s _vwz4cjiy _4bfu1r31 _1hms8stv _ajmmnqa1 _syazrbzz _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1"
                    ]),
                    children: (_data_tweetText = data.tweetText) !== null && _data_tweetText !== void 0 ? _data_tweetText : ""
                })
            })
        ]
    });
};

});

parcelRegister("2TQtV", function(module, exports) {
$parcel$export(module.exports, "ProductCTA", function () { return $d3b90cf8b4edc38c$export$73a34690202fd920; });
/* product-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $lFwc0 = parcelRequire("lFwc0");

var $fl7Kz = parcelRequire("fl7Kz");

var $kooLp = parcelRequire("kooLp");
const $d3b90cf8b4edc38c$export$73a34690202fd920 = (props)=>{
    var _props_asset, _props_asset1, _props_asset2;
    const { openModalForTemplate: openModalForTemplate } = (0, $lFwc0.useSiteSelectorContext)();
    const openSiteSelectorModal = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        var _props_dataBlueprintModule, _props_name;
        openModalForTemplate({
            templateId: (_props_dataBlueprintModule = props.dataBlueprintModule) !== null && _props_dataBlueprintModule !== void 0 ? _props_dataBlueprintModule : "",
            templateName: (_props_name = props.name) !== null && _props_name !== void 0 ? _props_name : "",
            productKey: props.productName
        });
    };
    var _props_url;
    const ctaUrl = (0, $kooLp.useLocalizedHref)((_props_url = props.url) !== null && _props_url !== void 0 ? _props_url : "");
    const ctaProps = props.dataBlueprintModule ? {
        buttonProps: {
            text: props.text,
            inputType: "button",
            type: "secondary",
            size: "small",
            onClick: openSiteSelectorModal // No dataEventProps as the SiteSelectorModal handles the analytics
        }
    } : {
        buttonProps: {
            text: props.text,
            type: "secondary",
            size: "small",
            url: ctaUrl,
            dataEventProps: {
                "data-product-key": "jiraSoftware",
                "data-event-component": "linkButton",
                "data-event-container": "siteSelectorModal",
                "data-event": "clicked"
            }
        }
    };
    // FIXME: These nested selectors are hacks to force the Card component to look like a product CTA card
    const productCTACss = null;
    var _props_title, _props_asset_url, _props_asset_description, _ref;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1pfh1tcg _85i5zwfg _1ir41y44 _6bmm14ds _9lfu1lct _15sh13la _fa07zwfg _49p6zwfg _17ihzwfg _ibjezwfg _jhc31hxd _1xqk13la _ym7q1h6o _1you1h6o _liug1fhb _lt831bp4 _18yx1ns9 _135z1ule _1umu1wug _3uw81wug _ge7e1wug _1yr51wug _hcapuuw1 _mezj1wug _64xw1bqd _uyj9gktf _xff7bfng _1of01bqd _p1067vkz _7iyz1nn1 _1jdc2hjt _byzn1osq"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $fl7Kz.default), {
            className: "product-cta-card",
            bodyText: props.valueProposition,
            headerText: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : "",
            pictureProps: {
                image: {
                    src: (_props_asset_url = (_props_asset = props.asset) === null || _props_asset === void 0 ? void 0 : _props_asset.url) !== null && _props_asset_url !== void 0 ? _props_asset_url : "",
                    alt: (_ref = (_props_asset_description = (_props_asset1 = props.asset) === null || _props_asset1 === void 0 ? void 0 : _props_asset1.description) !== null && _props_asset_description !== void 0 ? _props_asset_description : (_props_asset2 = props.asset) === null || _props_asset2 === void 0 ? void 0 : _props_asset2.name) !== null && _ref !== void 0 ? _ref : ""
                }
            },
            orientation: "horizontal",
            ctaProps: ctaProps
        })
    });
};

});


parcelRegister("82TGg", function(module, exports) {
$parcel$export(module.exports, "AgileAuthor", function () { return $44d05cacaf4e4b70$export$44bdcccc1a3ea89c; });
/* agile-author.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $ftgEA = parcelRequire("ftgEA");

var $kbpa7 = parcelRequire("kbpa7");
const $44d05cacaf4e4b70$export$44bdcccc1a3ea89c = ({ name: name, biography: biography, pictureSrc: pictureSrc, contentType: contentType })=>{
    if (!name || !biography || !pictureSrc) return null;
    const pictureProps = {
        src: pictureSrc,
        alt: name,
        baseWidth: 100,
        contentType: contentType
    };
    const containerCss = null;
    const nameCss = null;
    const biographyCss = null;
    const pictureCss = null;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _mqm21i89 _1pfh10yn _1q5110yn _1gde1bp4 _navj1q9c _ag851h6o _v736idpf _xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl12xx _1o9zidpf _1bsb53f4 _4t3i53f4 _6rth7vkz _s7n41q9y"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $ftgEA.ContentPlatformImage), (0, $dPABA._)((0, $6ogO3._)({}, pictureProps), {
                    className: (0, $2jatx.default)([
                        "_p12f1osq"
                    ])
                }))
            }),
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_bozggktf _s7n41q9y _v736idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1wyb1j6v _85i519bv _1p1dangw _syaz1mpp"
                        ]),
                        children: name
                    }),
                    /*#__PURE__*/ (0, $dypTs.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_ect4bzd7 _1wyb15s1 _syaz1mpp _vwz4bs82 _1pfhidpf _6rth1tcg _y3gn1e5h"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                        },
                        children: biography
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7tb7q", function(module, exports) {
$parcel$export(module.exports, "BodyTextContainer", function () { return $9b5fc1431c0c2ae6$export$4c2d02ebf4a10152; });
/* body-text-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $acgWW = parcelRequire("acgWW");
/**
 * Styles
 */ const $9b5fc1431c0c2ae6$var$headerCss = null;
const $9b5fc1431c0c2ae6$var$contentComponentWrapperCss = null;
const $9b5fc1431c0c2ae6$export$4c2d02ebf4a10152 = (props)=>{
    const { name: name, contentComponents: contentComponents } = props;
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthdlk8"
                ]),
                children: name
            }),
            contentComponents && contentComponents.map((component, idx)=>/*#__PURE__*/ (0, $dypTs.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_6rthgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $acgWW.RichContent), (0, $6ogO3._)({}, component))
                }, idx))
        ]
    }, name);
};

});

parcelRegister("4hXrx", function(module, exports) {
$parcel$export(module.exports, "NavigationCard", function () { return $a7958b82a2b207fa$export$1ea67d5e048e23b7; });
$parcel$export(module.exports, "useCardProps", function () { return $a7958b82a2b207fa$export$397757db538349a2; });
$parcel$export(module.exports, "NavigationCards", function () { return $a7958b82a2b207fa$export$b46258c722788b51; });
/* navigation-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $2jatx = parcelRequire("2jatx");

var $gljCV = parcelRequire("gljCV");

var $8e22h = parcelRequire("8e22h");

var $fl7Kz = parcelRequire("fl7Kz");

var $5HK05 = parcelRequire("5HK05");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $a7958b82a2b207fa$export$1ea67d5e048e23b7 = (props)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaText: ctaText, ctaHref: ctaHref, image: image, showLink: showLink } = props;
    const pictureProps = image ? {
        image: {
            src: image.url,
            alt: image.description ? image.name : ""
        }
    } : undefined;
    const ctaProps = ctaText && ctaHref ? {
        primaryLinkProps: {
            text: ctaText,
            href: ctaHref,
            // Localized from CPAPI?
            type: "primary",
            dataEventProps: {
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-product-key": "jiraSoftware",
                "data-event-container": "agileCardLink"
            }
        }
    } : undefined;
    const localizedCtaHref = (0, $kooLp.useLocalizedHref)(ctaHref !== null && ctaHref !== void 0 ? ctaHref : "");
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1osq _2rko1y44 _1m541cgf _2ebcglyw _gyir54rc _10gg14ds _80gp1cdp _3tur1osq _2mj61hna _9q85kb7n _1a7z1j6v _1wu5bs82 _17plb3bt _qkj51ule _17bx1hdd _1tegsxj9 _4bkb1ylp _1qv9grf3",
            !showLink && "_1knyglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)((0, $fl7Kz.default), {
                className: "navigation-card",
                headerText: headerText || "",
                bodyText: bodyText,
                eyebrowText: eyebrowText || "",
                orientation: "vertical",
                pictureProps: pictureProps,
                ctaProps: ctaProps
            }),
            ctaHref && /*#__PURE__*/ (0, $dypTs.jsx)("a", {
                href: localizedCtaHref,
                "aria-label": headerText || "",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-product-key": "jiraSoftware",
                "data-event-container": "agileCardLink",
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf"
                ])
            })
        ]
    });
};
const $a7958b82a2b207fa$var$isTutorial = (data)=>{
    return data.__typename === "ContentPlatformTutorial" || data.__typename === "Tutorial";
};
const $a7958b82a2b207fa$var$isHubArticle = (data)=>{
    return data.__typename === "ContentPlatformHubArticle" || data.__typename === "MicrositeArticle";
};
const $a7958b82a2b207fa$var$isProductFeature = (data)=>{
    return data.__typename === "ContentPlatformProductFeature" || data.__typename === "ProductFeature";
};
const $a7958b82a2b207fa$var$isFeaturedVideo = (data)=>{
    return data.__typename === "ContentPlatformFeaturedVideo" || data.__typename === "FeaturedVideo";
};
const $a7958b82a2b207fa$export$397757db538349a2 = (data, showLink)=>{
    const intl = (0, $8e22h.default)();
    const tutorialEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.tutorial-eyebrow",
        defaultMessage: "Tutorial"
    });
    const tutorialCtaText = intl.formatMessage({
        id: "agile.overview.navigation-cards.tutorial-cta",
        defaultMessage: "Try this tutorial"
    });
    const articleEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.article-eyebrow",
        defaultMessage: "Article"
    });
    const articleCtaText = intl.formatMessage({
        id: "agile.overview.navigation-cards.article-cta",
        defaultMessage: "Read this article"
    });
    const productFeatureEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.product-feature-eyebrow",
        defaultMessage: "Product Feature"
    });
    const featuredVideoEyeBrowText = intl.formatMessage({
        id: "agile.overview.navigation-cards.featured-video-eyebrow",
        defaultMessage: "Video"
    });
    const buildCardProps = (0, $gljCV.useCallback)(// eslint-disable-next-line complexity
    (cards, data)=>{
        var _data_callToAction_, _data_callToAction, _data_callToAction_1, _data_callToAction1;
        if ($a7958b82a2b207fa$var$isTutorial(data)) cards.push({
            eyebrowText: tutorialEyeBrowText,
            headerText: data.name,
            bodyText: data.description,
            ctaText: tutorialCtaText,
            ctaHref: data.urlSlug,
            image: data.tutorialBanner || undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : true
        });
        else if ($a7958b82a2b207fa$var$isHubArticle(data)) cards.push({
            eyebrowText: articleEyeBrowText,
            headerText: data.articleName,
            bodyText: data.description,
            ctaText: articleCtaText,
            ctaHref: data.urlSlug,
            image: (data === null || data === void 0 ? void 0 : data.articleBanner) || undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : false
        });
        else if ($a7958b82a2b207fa$var$isProductFeature(data)) cards.push({
            eyebrowText: productFeatureEyeBrowText,
            headerText: data.name,
            bodyText: data.description,
            ctaText: (_data_callToAction = data.callToAction) === null || _data_callToAction === void 0 ? void 0 : (_data_callToAction_ = _data_callToAction[0]) === null || _data_callToAction_ === void 0 ? void 0 : _data_callToAction_.text,
            ctaHref: (_data_callToAction1 = data.callToAction) === null || _data_callToAction1 === void 0 ? void 0 : (_data_callToAction_1 = _data_callToAction1[0]) === null || _data_callToAction_1 === void 0 ? void 0 : _data_callToAction_1.url,
            image: undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : true
        });
        else if ($a7958b82a2b207fa$var$isFeaturedVideo(data)) cards.push({
            eyebrowText: featuredVideoEyeBrowText,
            headerText: data.videoName,
            bodyText: data.description,
            ctaText: data.callToActionText,
            ctaHref: data.link,
            image: undefined,
            showLink: showLink !== null && showLink !== void 0 ? showLink : true
        });
        else console.error("Unknown next best action type", data);
        return cards;
    }, [
        tutorialEyeBrowText,
        tutorialCtaText,
        articleEyeBrowText,
        articleCtaText,
        productFeatureEyeBrowText,
        featuredVideoEyeBrowText,
        showLink
    ]);
    return (0, $gljCV.useMemo)(()=>data.reduce(buildCardProps, []), [
        buildCardProps,
        data
    ]);
};
const $a7958b82a2b207fa$export$b46258c722788b51 = (props)=>{
    var _cardsProps_slice;
    const cardsProps = $a7958b82a2b207fa$export$397757db538349a2((0, $5HK05.expectContent)(props.cardsData, "Next best action not found"), true);
    const navigationCardCss = null;
    return /*#__PURE__*/ (0, $dypTs.jsx)("div", {
        className: (0, $2jatx.default)([
            "_85i5ys9h _1q511wqb _1t4u1dfr _124xymf6 _php015vq _tgvo15vq _1d8u1j8p _1qeivwuj _1qef1crf _1adhl8b6 _bsma1tcg _crcvangw _15jft94y _q2dt3aqo _qliy1bqd"
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsxs)((0, $jMhSx.Row), {
            layout: "6-6",
            alignItems: "center",
            children: [
                (_cardsProps_slice = cardsProps.slice(0, 2)) === null || _cardsProps_slice === void 0 ? void 0 : _cardsProps_slice.map((props, index)=>/*#__PURE__*/ (0, $dypTs.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gljCV))).Fragment, {
                        children: /*#__PURE__*/ (0, $dypTs.jsx)($a7958b82a2b207fa$export$1ea67d5e048e23b7, (0, $6ogO3._)({}, props))
                    }, index)),
                cardsProps.length === 1 && /*#__PURE__*/ (0, $dypTs.jsx)("div", {})
            ]
        })
    });
};

});

parcelRegister("7ESW0", function(module, exports) {
$parcel$export(module.exports, "ShareUpNextBar", function () { return $2e0c7594a80cb0d4$export$c7e03914d4cb5822; });

var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $8e22h = parcelRequire("8e22h");
parcelRequire("bLI9O");
var $fzbzE = parcelRequire("fzbzE");

var $kooLp = parcelRequire("kooLp");
parcelRequire("k4yko");
var $7CmJH = parcelRequire("7CmJH");

var $1ka2O = parcelRequire("1ka2O");
function $2e0c7594a80cb0d4$var$useAgileShareUpNextProps(pageTree, title, description) {
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const origin = "https://www.atlassian.com";
    const link = `${origin}${location.pathname}`;
    const defaultNextUrlSlug = (0, $kooLp.useLocalizedHref)("/agile");
    const defaultNextName = intl.formatMessage({
        id: "Agile.main.default-next-page-title",
        defaultMessage: "Agile"
    });
    return (0, $gljCV.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            defaultNextPage: {
                name: defaultNextName,
                urlSlug: defaultNextUrlSlug
            },
            pageTree: pageTree
        }), [
        title,
        description,
        link,
        pageTree,
        defaultNextName,
        defaultNextUrlSlug
    ]);
}
const $2e0c7594a80cb0d4$export$c7e03914d4cb5822 = ({ nodes: nodes, title: title, description: description })=>{
    const agileShareUpNextProps = $2e0c7594a80cb0d4$var$useAgileShareUpNextProps(nodes, title, description);
    return /*#__PURE__*/ (0, $dypTs.jsx)((0, $fzbzE.ScrollUpBar), {
        sticky: true,
        anchor: "bottom",
        children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $7CmJH.AgileShareUpNext), (0, $6ogO3._)({}, agileShareUpNextProps))
    });
};

});
parcelRegister("bLI9O", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("fzbzE")).ScrollUpBar; });

var $fzbzE = parcelRequire("fzbzE");

});
parcelRegister("fzbzE", function(module, exports) {
$parcel$export(module.exports, "ScrollUpBar", function () { return $650ad6dedf8499d4$export$da8a398acf5e0aa8; });
/* scroll-up-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $ivZiR = parcelRequire("ivZiR");
const $650ad6dedf8499d4$var$TOP = "top";
const $650ad6dedf8499d4$var$BOTTOM = "bottom";
const $650ad6dedf8499d4$var$ScrollUpBarStyleMap = {
    base: "_v564x7w3 _t9ec1kli _kqsw1n9t",
    sticky: "_kqsw1if8",
    top: "_1r0417zq",
    bottom: "_1r041cj7",
    stuck: "_v5641ag2"
};
const $650ad6dedf8499d4$var$ScrollUpBarHiddenStyleMap = {
    top: "_t9ecz6y5",
    bottom: "_t9ec3k1b"
};
const $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap = {
    base: "_bfhku67f _aetrb3bt _18postnw _11fnglyw _9v7aidpf _1peqidpf _qc5ogcyp",
    top: "_11fnglyw _8x3udtpc",
    bottom: "_11fnglyw _8x3u4uke",
    stuck: "_1peqkb7n _11fnglyw _qc5o1pz1"
};
const $650ad6dedf8499d4$export$da8a398acf5e0aa8 = ({ children: children, sticky: sticky, anchor: anchor = $650ad6dedf8499d4$var$BOTTOM })=>{
    const [scrollRef, direction] = (0, $ivZiR.useVerticalScrollDirection)();
    const [topRef, topInView, topEntry] = (0, $jKShK.useInView)();
    const [bottomRef, bottomInView, bottomEntry] = (0, $jKShK.useInView)();
    // The `ScrollUpBar` is  always 'stuck' (aka fixed) by default.
    let stuck = true;
    if (sticky) // If the `ScrollUpBar` is sticky, it should only be 'stuck'
    // if it is not in view. Two sentinel elements are observed
    // (using `IntersectionObserver`) to determine if the `ScrollUpBar`
    // is in view. If the intersection observers haven't
    // initialized yet, default to assuming the bar is in view,
    // so that any 'stuck' state is not applied too eagerly.
    stuck = !(topInView || topEntry == null || bottomInView || bottomEntry == null);
    // The `ScrollUpBar` should only be hidden if it is stuck
    // and the user is scrolling down.
    const hidden = stuck && direction == "down";
    const containerStyle = [
        $650ad6dedf8499d4$var$ScrollUpBarStyleMap.base,
        $650ad6dedf8499d4$var$ScrollUpBarStyleMap[anchor],
        sticky && $650ad6dedf8499d4$var$ScrollUpBarStyleMap.sticky,
        stuck && $650ad6dedf8499d4$var$ScrollUpBarStyleMap.stuck,
        hidden && $650ad6dedf8499d4$var$ScrollUpBarHiddenStyleMap[anchor]
    ];
    const bgStyle = [
        $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap.base,
        $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap[anchor],
        stuck && $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap.stuck
    ];
    return /*#__PURE__*/ (0, $dypTs.jsxs)((0, $dypTs.Fragment), {
        children: [
            sticky ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                ref: topRef,
                "aria-hidden": "true",
                style: {
                    pointerEvents: "none",
                    visibility: "hidden"
                }
            }) : null,
            /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
                ref: scrollRef,
                className: (0, $2jatx.default)([
                    $650ad6dedf8499d4$var$ScrollUpBarStyleMap.base,
                    $650ad6dedf8499d4$var$ScrollUpBarStyleMap[anchor],
                    sticky && $650ad6dedf8499d4$var$ScrollUpBarStyleMap.sticky,
                    stuck && $650ad6dedf8499d4$var$ScrollUpBarStyleMap.stuck,
                    hidden && $650ad6dedf8499d4$var$ScrollUpBarHiddenStyleMap[anchor]
                ]),
                children: [
                    /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                        className: (0, $2jatx.default)([
                            $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap.base,
                            $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap[anchor],
                            stuck && $650ad6dedf8499d4$var$ScrollUpBarBackgroundStyleMap.stuck
                        ])
                    }),
                    children
                ]
            }),
            sticky ? /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                ref: bottomRef,
                "aria-hidden": "true",
                style: {
                    pointerEvents: "none",
                    visibility: "hidden"
                }
            }) : null
        ]
    });
};

});
parcelRegister("ivZiR", function(module, exports) {
$parcel$export(module.exports, "useVerticalScrollDirection", function () { return $da06e92f42a514dc$export$17c00a9141dd0ac6; });

var $gljCV = parcelRequire("gljCV");

var $2ve7k = parcelRequire("2ve7k");
function $da06e92f42a514dc$var$getScrollTop(node) {
    var _node_documentElement;
    var _node_documentElement_scrollTop, _ref;
    return (_ref = (_node_documentElement_scrollTop = node === null || node === void 0 ? void 0 : (_node_documentElement = node.documentElement) === null || _node_documentElement === void 0 ? void 0 : _node_documentElement.scrollTop) !== null && _node_documentElement_scrollTop !== void 0 ? _node_documentElement_scrollTop : node === null || node === void 0 ? void 0 : node.scrollTop) !== null && _ref !== void 0 ? _ref : 0;
}
function $da06e92f42a514dc$export$17c00a9141dd0ac6() {
    const scrollTop = (0, $gljCV.useRef)(0);
    const [direction, setDirection] = (0, $gljCV.useState)(null);
    const ref = (0, $gljCV.useCallback)((node)=>{
        if (!node) return;
        var _getNearestScrollNode;
        const scrollNode = (_getNearestScrollNode = (0, $2ve7k.getNearestScrollNode)(node)) !== null && _getNearestScrollNode !== void 0 ? _getNearestScrollNode : (0, $2ve7k.getWindow)(node);
        scrollNode === null || scrollNode === void 0 ? void 0 : scrollNode.addEventListener("scroll", (event)=>{
            const nextScrollTop = $da06e92f42a514dc$var$getScrollTop(event.target);
            const dir = nextScrollTop < scrollTop.current ? "up" : "down";
            scrollTop.current = nextScrollTop;
            setDirection(dir);
        });
    }, []);
    return [
        ref,
        direction
    ];
}

});



parcelRegister("k4yko", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("7CmJH")).AgileShareUpNext; });

var $7CmJH = parcelRequire("7CmJH");

});
parcelRegister("7CmJH", function(module, exports) {
$parcel$export(module.exports, "AgileShareUpNext", function () { return $f32bb9cb1816c92f$export$e5a57032b3ca2653; });
/* share-up-next.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $4k5wT = parcelRequire("4k5wT");

var $2CgMB = parcelRequire("2CgMB");

var $utZXI = parcelRequire("utZXI");
const $f32bb9cb1816c92f$var$AgileShareUpNextContainerStyle = null;
const $f32bb9cb1816c92f$var$ColumnStyles = null;
const $f32bb9cb1816c92f$export$e5a57032b3ca2653 = ({ defaultNextPage: defaultNextPage, pageTree: pageTree, description: description, link: link, title: title, source: source })=>{
    const nextPage = (0, $utZXI.useNextPage)(defaultNextPage, pageTree);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _bfhku67f _1tke1n2x _1n261g80 _s7n41q9y"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1ssb _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
                ]),
                children: description && link && title && /*#__PURE__*/ (0, $dypTs.jsx)((0, $4k5wT.SocialShareMenu), {
                    description: description,
                    link: link,
                    title: title,
                    source: source
                }) || /*#__PURE__*/ (0, $dypTs.jsx)("span", {})
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1ssb _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $dypTs.jsx)((0, $2CgMB.AgileUpNextLink), (0, $6ogO3._)({}, nextPage))
            })
        ]
    });
};

});
parcelRegister("4k5wT", function(module, exports) {
$parcel$export(module.exports, "SocialShareMenu", function () { return $15f336dfde624d51$export$22d14db7e0bd3bb5; });
/* social-share-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");

var $gljCV = parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $15f336dfde624d51$var$SocialShareButtonStyle = {
    base: "_1e0c1o8l _1bsb1u1b _4t3i1u1b _1reo15vq _18m915vq",
    facebook: "_11q7621r",
    twitter: "_11q788zb",
    linkedin: "_11q71e9h"
};
const $15f336dfde624d51$var$SocialShareButtonActions = {
    facebook: {
        action: "https://www.facebook.com/dialog/feed",
        params: (props)=>({
                app_id: "743864389089816",
                caption: props.title,
                link: props.link,
                description: props.description,
                picture: "",
                name: props.title
            })
    },
    twitter: {
        action: "https://twitter.com/share",
        params: (props)=>({
                text: props.description,
                url: props.link,
                via: props.source
            })
    },
    linkedin: {
        action: "https://www.linkedin.com/shareArticle",
        params: (props)=>({
                mini: "true",
                url: props.link,
                title: props.title,
                summary: props.description,
                source: props.source
            })
    }
};
const $15f336dfde624d51$var$SocialShareButton = ({ title: title, variant: variant, action: action })=>{
    const href = (0, $gljCV.useMemo)(()=>{
        const actionDescriptor = $15f336dfde624d51$var$SocialShareButtonActions[variant];
        const url = new URL(actionDescriptor.action);
        const params = new URLSearchParams(actionDescriptor.params(action));
        for (const [key, value] of params.entries())url.searchParams.set(key, value);
        return url.href;
    }, [
        variant,
        action
    ]);
    const clickHandler = (0, $gljCV.useCallback)((e)=>{
        if (typeof window !== "undefined") {
            window.open(href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600");
            e.preventDefault();
        }
    }, [
        href
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        title: title,
        onClick: clickHandler,
        className: (0, $2jatx.default)([
            $15f336dfde624d51$var$SocialShareButtonStyle.base,
            $15f336dfde624d51$var$SocialShareButtonStyle[variant]
        ]),
        children: /*#__PURE__*/ (0, $dypTs.jsx)("span", {
            style: {
                pointerEvents: "none",
                visibility: "hidden"
            },
            children: title
        })
    });
};
const $15f336dfde624d51$var$SocialShareMenuStyle = null;
const $15f336dfde624d51$export$22d14db7e0bd3bb5 = ({ description: description, link: link, title: title, source: source })=>{
    const intl = (0, $8e22h.default)();
    const action = (0, $gljCV.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            source: source !== null && source !== void 0 ? source : "Atlassian"
        }), [
        description,
        link,
        title,
        source
    ]);
    return /*#__PURE__*/ (0, $dypTs.jsxs)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _17yb1u1b"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)($15f336dfde624d51$var$SocialShareButton, {
                    variant: "facebook",
                    action: action,
                    title: intl.formatMessage({
                        id: "Agile.share-menu.facebook",
                        defaultMessage: "Share on Facebook"
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)($15f336dfde624d51$var$SocialShareButton, {
                    variant: "twitter",
                    action: action,
                    title: intl.formatMessage({
                        id: "Agile.share-menu.twitter",
                        defaultMessage: "Share on Twitter"
                    })
                })
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("li", {
                children: /*#__PURE__*/ (0, $dypTs.jsx)($15f336dfde624d51$var$SocialShareButton, {
                    variant: "linkedin",
                    action: action,
                    title: intl.formatMessage({
                        id: "Agile.share-menu.linkedin",
                        defaultMessage: "Share on LinkedIn"
                    })
                })
            })
        ]
    });
};

});

parcelRegister("2CgMB", function(module, exports) {
$parcel$export(module.exports, "AgileUpNextLink", function () { return $23e1d8f848490b98$export$d6aa7a1a39df0b76; });
/* up-next-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $dypTs = parcelRequire("dypTs");
parcelRequire("gljCV");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");
// NOTE: Extracted from "@/libraries/wpl/foundations/src/icons/basic/arrow-right-no-circle"
// because it does not support 'currentcolor'.
// see: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#currentcolor_keyword
const $23e1d8f848490b98$var$ArrowRightNoCircle = ()=>/*#__PURE__*/ (0, $dypTs.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 11 8",
        fill: "none",
        children: /*#__PURE__*/ (0, $dypTs.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z",
            fill: "currentcolor"
        })
    });
const $23e1d8f848490b98$var$AgileUpNextLinkContainerStyle = null;
const $23e1d8f848490b98$var$AgileUpNextLinkTextStyle = null;
const $23e1d8f848490b98$var$AgileUpNextLinkArrowStyle = null;
const $23e1d8f848490b98$export$d6aa7a1a39df0b76 = ({ name: name, urlSlug: urlSlug })=>{
    const intl = (0, $8e22h.default)();
    const linkText = intl.formatMessage({
        id: "Agile.main.up-next-link",
        defaultMessage: "Up Next"
    });
    return /*#__PURE__*/ (0, $dypTs.jsxs)("div", {
        "data-testid": "agile-up-next-link",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvresu3"
        ]),
        children: [
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _19pk1lpd _2hwx1ul9 _otyridpf _18u0idpf"
                ]),
                children: linkText
            }),
            /*#__PURE__*/ (0, $dypTs.jsx)("div", {
                children: /*#__PURE__*/ (0, $dypTs.jsxs)("a", {
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "agileUpNextLink",
                    "data-product-key": "jiraSoftware",
                    href: (0, $kooLp.useLocalizedHref)(urlSlug),
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bahesu3 _1n261q9c _zulp19bv _syazrbzz _1wyb1k92 _y3gnusic _vwz4kb7n _1acvf6fq _tvyuz12g _14mws58n _1qjc1txw _173k1h6o _zq3l1h6o _1r42idpf _30l3oelr _v6ed1jfq _uxxm1wug _so7d1j6v"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            children: name
                        }),
                        /*#__PURE__*/ (0, $dypTs.jsx)("span", {
                            className: "link-arrow-up-next",
                            children: /*#__PURE__*/ (0, $dypTs.jsx)($23e1d8f848490b98$var$ArrowRightNoCircle, {})
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("utZXI", function(module, exports) {
$parcel$export(module.exports, "useNextPage", function () { return $6b96fada122746b4$export$1075e8f8ce8db3ce; });

var $gljCV = parcelRequire("gljCV");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");
function $6b96fada122746b4$var$isLocation(urlSlug, location) {
    const url = new URL((0, $80kL5.delocalizePathname)(urlSlug), location.origin);
    return (0, $80kL5.isEqualUnlocalizedPathname)(url.pathname, location.pathname) && url.hash == location.hash;
}
function $6b96fada122746b4$var$findNextPage(nodes, location) {
    let foundCurrent = false;
    const queue = [
        ...nodes
    ].reverse();
    while(queue.length){
        const next = queue.pop();
        if (!next) continue;
        if (next.urlSlug && $6b96fada122746b4$var$isLocation(next.urlSlug, location)) foundCurrent = true;
        else if (foundCurrent && next.urlSlug != null) return {
            name: next.name,
            urlSlug: next.urlSlug
        };
        if ((next === null || next === void 0 ? void 0 : next.children) != null) for(let i = next.children.length - 1; i >= 0; i--){
            const child = next.children[i];
            if (child) queue.push(child);
        }
    }
    return null;
}
function $6b96fada122746b4$export$1075e8f8ce8db3ce(root, nodes) {
    const location = (0, $1ka2O.useLocation)();
    return (0, $gljCV.useMemo)(()=>{
        // Base case: current location is agile hub landing page,
        // so find the first node with a `urlSlug`.
        if ($6b96fada122746b4$var$isLocation(root.urlSlug, location)) for (const node of nodes){
            if (node.urlSlug != null) return {
                name: node.name,
                urlSlug: node.urlSlug
            };
        }
        var _findNextPage;
        // Otherwise, find the next page.
        // If the current location is not found, or there is
        // no page after the current location, return the root.
        return (_findNextPage = $6b96fada122746b4$var$findNextPage(nodes, location)) !== null && _findNextPage !== void 0 ? _findNextPage : root;
    }, [
        root,
        nodes,
        location
    ]);
}

});





//# sourceMappingURL=agile-article.6803f3d3.js.map
